import React, { useContext, useEffect, useState } from 'react';
import { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import { Box } from '@material-ui/core';
import Account from '../Account';
import { ReactComponent as IAMLogo } from 'src/images/iam_logo.svg';

import { useHistory, useLocation } from 'react-router';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import GuestHeader from './GuestHeader';
const useStyles = makeStyles(() => ({
  wrapper: {
    // marginLeft: 67,
    // paddingLeft: 67,
    padding: '0 16px 0 80px',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 3
  },
  openWrapper: {
    marginLeft: 185,
    padding: '0 1rem 0 2rem',
    width: 'calc(100% - 185px)',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: '#fff',
    zIndex: 99
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontFamily: 'Archivo',
    color: '#000',
    fontSize: 26,
    fontWeight: 500
  },
  subTitle: {
    fontFamily: 'Archivo',
    color: '#9a9a9a',
    fontSize: 16,
    fontWeight: 400
  },

  hr: {
    height: 1,
    border: 0,
    backgroundColor: '#D9D9D9'
  },

  logo: {
    width: 64,
    height: 24
  }
}));

const UiHeader: FC<{ visible: boolean }> = ({ visible }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [guestMode, setGuestMode] = useState(false);
  const { authStatus } = useContext(AuthContext);

  const onClickLogo = () => {
    history.push('/workspace/draft');
  };
  const onClickLogoGuest = () => {
    window.location.href = 'https://www.inappmessage.com';
  };

  useEffect(() => {
    if (
      authStatus !== AuthStatus.SignedIn &&
      location.pathname === '/workspace/templates'
    ) {
      setGuestMode(true);
    } else {
      setGuestMode(false);
    }
  }, [authStatus]);

  return (
    <Box className={visible ? classes.openWrapper : classes.wrapper}>
      <Box className={classes.topBar}>
        {guestMode ? (
          <GuestHeader
            onClickLogoGuest={onClickLogoGuest}
            style={{ background: 'none', color: 'black' }}
          />
        ) : (
          <>
            <Box>
              <IAMLogo className={classes.logo} onClick={onClickLogo} />
            </Box>
            <Account />
          </>
        )}
      </Box>
    </Box>
  );
};

export default UiHeader;
